import TimelineLite from 'gsap/TimelineLite';
import $ from 'jquery';
import contentBlocker from 'content-blocker';
import template from '../html/modal.handlebars';


export default class ModalController {
    static getInstance() {
        if (ModalController.instance === null) {
            ModalController.instance = new ModalController();
        }
        return ModalController.instance;
    }

    constructor() {
        this.$body = $('body');
        // #form is kentico page wrapper
        this.form = $('#form');
        this.form.append(template);
        this.containerSelector = '.js-modal-container';
        this.contentSelector = '.js-modal-content';
        this.contentWrapperSelector = '.js-modal-content-wrapper';
        this.closeSelector = '.js-modal-close';

        this.container = document.querySelector(this.containerSelector);
        if (this.container) {
            this.closeBtn = this.container.querySelector(this.closeSelector);
            this.content = this.container.querySelector(this.contentSelector);
            this.content = $(this.content);

            this.modalTween = new TimelineLite({ paused: true });
            this.modalTween.fromTo(this.container, 0.0, { visibility: 'hidden' }, { visibility: 'visible' });
            this.modalTween.fromTo(this.container, 0.5, { opacity: '0' }, { opacity: '1' });
            this.openedInstance = null;
            this.isOpened = false;

            const $document = $(document);
            $document.on('click', this.closeSelector, this._closeByUserHandle.bind(this));
            $document.on('click touchstart', this._outerClickHandle.bind(this));
        }
    }

    _outerClickHandle(e) {
        if (this.isOpened) {
            const $target = $(e.target);

            if ($target.is(this.container) || $target.parents(this.containerSelector).length) {
                if ($target.is(this.contentWrapperSelector) || $target.parents(this.contentWrapperSelector).length) {
                    return;
                }
                this._closeByUserHandle();
            }
        }
    }

    _closeByUserHandle() {
        if (this.openedInstance && this.openedInstance.options.closable) {
            this.close();
        }
    }

    _renderContent(content) {
        this.content.empty().append(content);
    }

    _renderLayout() {
        this.modalTween.play();
    }

    close() {
        this.modalTween.reverse();
        this._beforeClose(this.openedInstance);
        this.openedInstance = null;
        this.isOpened = false;
    }

    open(modal, refresh = false) {
        if (this.openedInstance) {
            if (this.openedInstance === modal) {
                return;
            }
            this.close();
            this.openedInstance = null;
        }
        this.openedInstance = modal;
        this.isOpened = true;

        if (!this.openedInstance.options.closable) {
            this.closeBtn.classList.add('is-hidden');
        } else {
            this.closeBtn.classList.remove('is-hidden');
        }

        this._renderLayout();
        modal.getPreparedContent(refresh).then((content) => {
            this._renderContent(content);
        }).then(() => {
            this._afterOpen(modal);
        });
    }

    _afterOpen() {
        contentBlocker.block('modal');
        this.container.style['-webkit-overflow-scrolling'] = 'touch';
    }

    _beforeClose() {
        contentBlocker.unblock('modal');
        this.container.style['-webkit-overflow-scrolling'] = 'auto';
    }
}

ModalController.instance = null;



// WEBPACK FOOTER //
// ./app/components/modal/js/modal-controller.js